/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * Číselník typů úložných jednotek zařízení.
 * @enum {'internal' | 'sdcard' | 'usb'}
 * @readonly
 */
const FileSystemType = /** @type {const} */ ({
  /** Úložná jednotka, která je vnitřní součástí zařízení. */
  Internal: 'internal',
  /** Úložiště rozšířené pomocí SD karty. */
  SdCard: 'sdcard',
  /** Úložiště rozšířené pomocí USB. */
  Usb: 'usb'
});

export default FileSystemType;
